import { useSelector } from 'react-redux'
import { selectOrderlineDetailList } from '../../../../features/projectManagement/projectManagementSlice'
import PmrE2EProjectDetailsOrderlineModel, {
  isRowCompleted,
} from '../interfaces/pmr-e2e-project-details-orderline-model'
import ProjectOrderlineStatus from '../enums/project-orderline-status'

export const useProjectOrderLines = (projectId: String) => {
  const orderlineDetailList = useSelector(selectOrderlineDetailList)
  const orderLines =
    orderlineDetailList.find(list => list.projectId === projectId)?.orderlineDetailList || []

  const isNotCompletedNorCancelled = (line: PmrE2EProjectDetailsOrderlineModel) =>
    !isRowCompleted(line) && line.orderLineStatus !== ProjectOrderlineStatus.Cancelled

  const validSelectedRows = () => {
    return orderLines.filter(line => line.isChecked && isNotCompletedNorCancelled(line))
  }

  const activeProjectOrderLines = () => {
    return orderLines.filter(line => isNotCompletedNorCancelled(line))
  }

  return {
    orderlineDetailList,
    orderLines,
    validSelectedRows,
    activeProjectOrderLines,
  }
}
